import * as React from "react"
import { cn } from "@/lib/class-control"

interface TextareaProps extends React.ComponentProps<"textarea"> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-input-default w-full rounded-lg bg-[#15203c] px-input-x py-input-y text-sm text-white",
          "border-0.5 border-[#5d5d5d] placeholder:text-[#d1d1d1]",
          "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary focus-visible:ring-offset-0",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-[#0c1427]",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
